import { render, staticRenderFns } from "./ProgramSettings.vue?vue&type=template&id=0f145ee7&scoped=true&lang=pug&"
import script from "./ProgramSettings.vue?vue&type=script&lang=js&"
export * from "./ProgramSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSettings.vue?vue&type=style&index=0&id=0f145ee7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f145ee7",
  null
  
)

export default component.exports